import React from "react";
import { FormattedMessage } from "react-intl";

const TimeToRead = props => (
    <span>
        {props.timeToRead} <FormattedMessage id="minutes-of-reading" />
    </span>
)

export default TimeToRead